import { gql, useQuery } from '@apollo/client';
import { EMPTY_ARRAY } from '@modules/common/constants';
import { GetAssistantSamplesInput, Query } from 'generated/graphql';
import { useGetUser } from 'v2/core/services/user';

const GET_ASSISTANT_SAMPLES = gql`
  query getAssistantSamples($tenantID: ID!, $userID: ID!) {
    getAssistantSamples(request: { tenantID: $tenantID, userID: $userID }) {
      presets {
        header
        question
        type
      }
    }
  }
`;

export function useFetchWisdomSuggestions() {
  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();

  const { loading, data } = useQuery<Query, GetAssistantSamplesInput>(
    GET_ASSISTANT_SAMPLES,
    {
      variables: {
        tenantID,
        userID,
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    },
  );

  const suggestions = data?.getAssistantSamples?.presets;

  return {
    isLoading: suggestions ? false : loading,
    suggestions: suggestions ?? EMPTY_ARRAY,
  } as const;
}
